import { useMemo } from "react";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { useQuery } from "@tanstack/react-query";
import { fetchMachineList } from "../../../fetchers/machine";
import { useTheme, MenuItem, Select } from "@mui/material";
import { tokens } from "../../../assets/theme";
import messages from "./messages";
import { FormattedMessage } from "react-intl";

export default function MachineNavigationDropdown(props) {
    const [ companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const machinesQuery = useQuery({
            queryKey: ['machinelist', companyKey], 
            queryFn: () => fetchMachineList(companyKey),
            staleTime: 60000,
            refetchInterval: 60000,
        })

    const machinesOptions = useMemo(() => {
        const arr = machinesQuery.data ?? [];
        return arr.toSorted
            ? arr.toSorted((a, b) => a.machineName.localeCompare(b.machineName))
            : [...arr].sort((a, b) => a.machineName.localeCompare(b.machineName));
    }, [machinesQuery.data]);
    
    if (machinesQuery.isLoading || machinesQuery.isError) {
        return <></>;
    }

    return (
        <Select
            size="small"
            name="machine"
            defaultValue="" 
            displayEmpty    
            sx={{ "& .MuiOutlinedInput-notchedOutline": { border: "none" } }}
            onChange={(e) => {
                if (e.target.value) {
                    window.location.href = `/machines/${e.target.value}`;
                }
            }}
        >
            <MenuItem value="" disabled>
                <FormattedMessage {...messages.quickSelectMachine} />
            </MenuItem> 
            { machinesOptions.map((machine) => (
                <MenuItem key={machine.id} value={machine.id}>
                    {machine.machineName}
                </MenuItem>
            )) }
        </Select>
    );
};

